// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","tagline":"Footer_tagline__qJLMq"};